import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '@shared/services/shared.service';
import { IHouseholdInteraction } from 'app/models/household/household-interaction';
import { HouseholdService } from 'app/services/household-service';
import { IHouseholdLetter } from 'app/models/household/household-letter';
import { HouseholdLetterUpload } from 'app/models/household/household-letter-upload';
import { SendLetterComponent } from 'app/components/vouchers/letters/send/send-letter.component';
import { DialogEditHouseholdComponent } from '../edit/household-edit-dialog';
import { EditSampleComponent } from 'app/components/well/samples/edit/edit-samples.component';
import { HouseholdExceedenceLetterComponent } from './nitrate-exceedance/household-exceedence-letter.component';
import { AttachHouseholdLetterComponent } from './attach-household-letter.component';
import { COCHouseholdLetterComponent } from './chain-of-custody/coc-household-letter.component';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { AuthService } from '@shared/auth/auth.service';

@Component({
  selector: 'household-letters',
  templateUrl: './household-letters.component.html',
  styleUrls: ['./household-letters.component.scss']
})
export class HouseholdLettersComponent implements OnInit {
  @Input('householdId')
  householdId: number = 0;
  householdAttachment: HouseholdLetterUpload = undefined;
  processing: boolean = false;
  loading: boolean = false;
  downloading: boolean = false;
  displayedColumns: string[] = ['householdId','sampleId','letterType','complete','sentInfo','actions'];
  dataSource = new MatTableDataSource<IHouseholdLetter>();
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;
  pageSize = 10;
  resultSize: number = 0;
  letters: IHouseholdLetter[] = [];
  cocGenerated: boolean = false;

  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase(); 
  }

  constructor(public dialog: MatDialog,
    public householdService: HouseholdService,
    public oregonWellDataService: OregonWellDataService,
    public authService: AuthService,
    private toastr: ToastrService,
    private sharedService: SharedService) {
  }
  ngOnInit(): void {
    this.load();
  }
 
  load() {
    this.loading = true;
    this.householdService.getHouseholdLetters(this.householdId).subscribe(
      result => {
        this.letters = result;
        
        if(this.letters.filter(l => l.letterType == this.householdService.householdCOCLetterType).length > 0){
          this.cocGenerated = true;
         }
         else {
           this.cocGenerated = false;
         }
        this.dataSource = new MatTableDataSource<IHouseholdLetter>(result);
        this.resultSize = result.length;
        this.loading = false;
      },
      error => {
        this.loading = false;
      },
      () => {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  generateCOC() {
    
    const generateLetter: HouseholdLetterUpload = {
      id: 0,
      letterHtml: '',
      letterType: this.householdService.householdCOCLetterType,
      parameterResultId: 0,
      sampleId: 0,
      letterContent: '',
      householdId: this.householdId,   
      base64File: ''   
    }
      const dialogRef = this.dialog.open(COCHouseholdLetterComponent, {
        width: '90%',
        data: generateLetter,
      });
      dialogRef.afterClosed().subscribe(result => {
        this.load();
      });
  }

  downloadHouseholdLetter(id: number,  letterType: string, parameterResultId: number) {
    let fileName = letterType;
    if (parameterResultId > 0) {
      fileName = fileName + "-" + parameterResultId;
    }
    this.downloading = true;
    this.householdService.downloadHouseholdLetter(id).subscribe(
      (response) => {
        this.sharedService.downloadFile(fileName, response)
        this.downloading = false;
      },
      (error) => {
        console.log("error", error);
        this.downloading = false;
      }
    );
  }

  editSample(sampleId: number){
    const dialogRef = this.dialog.open(EditSampleComponent, {
      width: '90%',
      data: sampleId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  generateHouseholdLetter(letterType: string, parameterResultId: number, sampleId: number, householdId: number) {

    
    const generateLetter: HouseholdLetterUpload = {
      id: 0,
      letterHtml: '',
      letterType: letterType,
      parameterResultId: parameterResultId,
      sampleId: sampleId,
      letterContent: '',
      householdId: householdId,
      base64File: ''
    }

    if(letterType == this.householdService.householdExceedanceLetterType ||
      letterType == this.householdService.householdNoExceedanceLetterType ){
        const dialogRef = this.dialog.open(HouseholdExceedenceLetterComponent, {
          width: '90%',
          data: generateLetter,
        });
        dialogRef.afterClosed().subscribe(result => {
          this.load();
        });
      }
      else {        
         this.toastr.error("Unsupported Letter Type");
      }
  }

  sendHouseholdLetter(letterId: number) {
    let letter = this.letters.find(l => l.id == letterId);
    const dialogRef = this.dialog.open(SendLetterComponent, {
      width: '70%',
      data: letter,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }



  attachHoulseholdLetter(householdId: number, letterType: string, sampleId: number, parameterResultId: number) {
    this.householdAttachment = {
      id: 0,
      letterHtml: '',
      letterType: letterType,
      parameterResultId: parameterResultId,
      sampleId: sampleId,
      letterContent: '',
      householdId: householdId,
      base64File: ''
    };

    
    const dialogRef = this.dialog.open(AttachHouseholdLetterComponent, {
      width: '70%',
      data: this.householdAttachment,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }



  delete(id: number) {
    this.sharedService.openConfirm("Are you sure you want to remove this letter?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.processing = true;
        this.householdService.deleteHouseholdLetter(id).subscribe(
          result => {
            this.toastr.success("Letter Removed");
            this.load();
            this.processing = false;
          },
          error => {
            this.toastr.error("Unable to remove letter.");
            this.processing = false;
          }
        );
      }
    });
  }
  
  deleteHouseholdLetter(id: number) {
    this.sharedService.openConfirm("Are you sure you want to remove this household letter?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.processing = true;
        this.householdService.deleteHouseholdLetter(id).subscribe(
          result => {
            this.toastr.success("Letter Removed");
            this.load();
            this.processing = false;
          },
          error => {
            this.toastr.error("Unable to remove letter");
            this.processing = false;
          }
        );
      }
    });
  }
}